<template lang="html">
  <div id="landingPage" class="row pt-5">
    <!-- <div class="col-12" id="topMargin">

    </div> -->
    <div class="col-1" id="leftSidebar">

    </div>
    <div class="col-10" id="middle">
      <div style="height: 12vh;">

      </div>
      <div class="row">
        <div class="col-2">

        </div>
        <div class="col-2">
          <a :href="projectLinks.projectInduction" target="_blank">
            <b-img src='img/main_icons/project_induction.png' fluid alt="..." rounded/></b-img>
          </a>
        </div>
        <div class="col-2">
          <a :href="projectLinks.designPortal" target="_blank">
            <b-img src='img/main_icons/designportal.png' fluid alt="..." rounded/></b-img>
          </a>
        </div>
        <div class="col-2">
          <a :href="projectLinks.referenceDesign" target="_blank">
            <b-img src='img/main_icons/data_room.png' fluid alt="..." rounded/></b-img>
          </a>
        </div>
        <div class="col-2">
          <a :href="projectLinks.deliverablesManagement" target="_blank">
            <b-img src='img/main_icons/deliverables_management.png' fluid alt="..." rounded/></b-img>
          </a>
        </div>
      </div>
      <div style="height:4vh;">

      </div>
      <div class="row">
        <div class="col-3">

        </div>
        <div class="col-2">
          <a :href="projectLinks.messageBoard" target="_blank">
            <b-img src='img/main_icons/communication_tool.png' fluid alt="..." rounded/></b-img>
          </a>
        </div>
        <div class="col-2">
          <a :href="projectLinks.timesheet" target="_blank">
            <b-img src='img/main_icons/timesheet.png' fluid alt="..." rounded/></b-img>
          </a>
        </div>
        <div class="col-2">
          <a :href="projectLinks.contactList" target="_blank">
            <b-img src='img/main_icons/contact_list.png' fluid alt="..." rounded/></b-img>
          </a>
        </div>
      </div>
    </div>
    <!-- <div class="col-10" id="middle">
      <div style="height: 16vh;">

      </div>

      <div class="row">
        <div class="row" style="">
          <div class="col-1">

          </div>
          <div class="col-2">
            <a :href="projectLinks.projectInduction" target="_blank">
              <b-img src='img/main_icons/project_induction.png' fluid alt="..." rounded/></b-img>
            </a>
          </div>
          <div class="col-2">
            <a :href="projectLinks.designPortal" target="_blank">
              <b-img src='img/main_icons/designportal.png' fluid alt="..." rounded/></b-img>
            </a>
          </div>
          <div class="col-2">
            <a :href="projectLinks.referenceDesign" target="_blank">
              <b-img src='img/main_icons/data_room.png' fluid alt="..." rounded/></b-img>
            </a>
          </div>
          <div class="col-2">
            <a :href="projectLinks.deliverablesManagement" target="_blank">
              <b-img src='img/main_icons/deliverables_management.png' fluid alt="..." rounded/></b-img>
            </a>
          </div>

        </div>
        <div style="height:2vh;">

        </div>
        <div class="row" style="">
          <div class="col-1">

          </div>
          <div class="col-2">
            <a :href="projectLinks.messageBoard" target="_blank">
              <b-img src='img/main_icons/communication_tool.png' fluid alt="..." rounded/></b-img>
            </a>
          </div>
          <div class="col-2">
            <a :href="projectLinks.timesheet" target="_blank">
              <b-img src='img/main_icons/timesheet.png' fluid alt="..." rounded/></b-img>
            </a>
          </div>
          <div class="col-2">
            <a :href="projectLinks.contactList" target="_blank">
              <b-img src='img/main_icons/contact_list.png' fluid alt="..." rounded/></b-img>
            </a>
          </div>
        </div>
      </div>
    </div> -->
    <div class="col-1 " id="rightSidebar">
      <a class="col-12 align-right" :href="softwareLinks.projectwise" target="_blank">
        <b-img src='img/software_icons/projectwise.png' fluid alt="..." rounded/></b-img>
      </a>
      <a class="col-12" :href="softwareLinks.bim360" target="_blank">
        <b-img src='img/software_icons/bim360.png' fluid alt="..." rounded/></b-img>
      </a>
      <a class="col-12" :href="softwareLinks.software3" target="_blank">
        <b-img src='img/software_icons/software3.png' fluid alt="..." rounded/></b-img>
      </a>
      <a class="col-12" :href="softwareLinks.software4" target="_blank">
        <b-img src='img/software_icons/software4.png' fluid alt="..." rounded/></b-img>
      </a>
      <a class="col-12" :href="softwareLinks.teams" target="_blank">
        <b-img src='img/software_icons/msteams.png' fluid alt="..." rounded/></b-img>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "LandingPage",
  data() {
    return {
      projectLinks: {
        projectInduction: "https://under-construction.geodemosolutions.com/",
        projectInsight: "/projectInsight",
        projectManagement: "https://under-construction.geodemosolutions.com/",
        // designPortal: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=ba371bb04e3f42fcb3938c24a7577e3d",
        designPortal: "https://under-construction.geodemosolutions.com/", // CPRP Design Portal link
        timesheet: "https://under-construction.geodemosolutions.com/",
        referenceDesign: "https://under-construction.geodemosolutions.com/",
        humanResource: "https://under-construction.geodemosolutions.com/",
        deliverablesManagement: "https://under-construction.geodemosolutions.com/",
        messageBoard: "https://under-construction.geodemosolutions.com/",
        contactList: "https://under-construction.geodemosolutions.com/"
      },
      softwareLinks: {
        // projectwise: "https://connect-projectwisewac.bentley.com/pwlink?datasource=Bentley.PW--arcadis-au-pw.bentley.com~3Aarcadis-au-02&objectId=32416513-897b-42e2-8022-8f51ab86cf78&objectType=project",
        projectwise: "https://www.bentley.com/en/products/brands/projectwise",
        bim360: "https://under-construction.geodemosolutions.com/",
        software3: "https://under-construction.geodemosolutions.com/",
        software4: "https://under-construction.geodemosolutions.com/",
        teams: "https://www.microsoft.com/en/microsoft-365/microsoft-teams/group-chat-software"
        // teams: "https://teams.microsoft.com/l/channel/19%3a7126b741241a45e496ec2a837bf78553%40thread.tacv2/General?groupId=2183df77-13f2-479a-91f7-bd855fa687f2&tenantId=7f90057d-3ea0-46fe-b07c-e0568627081b"
      }
    }
  },
  methods: {
    buttonClicked: function(id) {
      // console.log(id);
      // console.log(this.$router);
      this.$router.push({ name: 'MainApp', params: { activeTab: id } })
    }
  }
}
</script>

<style>
  #landingPage {
    width: 100vw;
    height: 84.5vh;
    margin: 0;
    /* background-color: black; */
  }
  #topMargin {
    /* height: 1vh; */
  }
  #leftSidebar {
    /* background-color: blue; */
  }
  #rightSidebar > a  {
    /* background-color: blue; */
    /* padding:0; */

  }
  #rightSidebar > a > img {
    /* background-color: blue; */
    /* padding:0; */
    height: 45px;
    margin-bottom: 1vh;
  }
  .bigButton {
    margin-top: 6vh;
    width: 25vw!important;
    height: 25vh!important;
    background: rgba(128, 128, 128, 0.3)
  }
  .bigButton:hover, .bigButton:active {
    background: rgba(128, 128, 128, 0.5)!important;
  }
  .btn-customorange{
    color: #fff;
    background-color: #E4610F !important;
    border-color: #adb5bd !important;
  }

  .btn-customorange:hover{
    color: #fff;
    background-color: #E4610F !important;
    border-color: rgba(30, 29, 36, 0.4) !important;
    /* border-color: transparent !important; */
  }

  .btn-customorange:not(:disabled):not(.disabled):active, .btn-customorange:not(:disabled):not(.disabled).active, .show > .btn-customorange.dropdown-toggle {
    color: #fff;
    background-color: #E4610F !important;
    border-color: rgba(30, 29, 36, 0.4) !important;
    /* border-color: transparent !important; */
  }

  .list-group-item {
    margin-bottom: 0.5vh !important;
    background-color:rgba(128, 128, 128, 0.7) !important;
  }
</style>
